import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form } from 'react-bootstrap';
import { DateTimeInput, Input } from '../../../common/components/formControls';
import validators from '../../../common/services/validators';
import { withTranslation } from 'react-i18next';

const XeroInputDataForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, t }) => {
	const colSize = { labelCol: 4, valueCol: 8 };
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			<Field name='invoiceDate' component={DateTimeInput} showTime={false} horizontal required label={t('Xero_InvoiceDate')} {...colSize} validate={[validators.required]} />
			<Field name='firstInvoiceNumber' component={Input} horizontal required label={t('Xero_FirstInvoiceNumber')} {...colSize} validate={[validators.required, validators.integer]} />
			<Field name='reference' component={Input} horizontal required label={t('Xero_Reference')} {...colSize} validate={[validators.required]} />
			<Field name='trackingName' component={Input} horizontal required label={t('Xero_TrackingName')} {...colSize} validate={[validators.required]} />
			<Field name='royaltyCode' component={Input} horizontal required label={t('Xero_RoyaltyCode')} {...colSize} validate={[validators.required]} />
			<Field name='royaltyTrackingValue' component={Input} horizontal required label={t('Xero_RoyaltyTrackingValue')} {...colSize} validate={[validators.required]} />
			<Field name='marketingLevyCode' component={Input} horizontal required label={t('Xero_MarketingLevyCode')} {...colSize} validate={[validators.required]} />
			<Field name='marketingLevyTrackingValue' component={Input} horizontal required label={t('Xero_MarketingLevyTrackingValue')} {...colSize} validate={[validators.required]} />
		</Form>
	);
};

export default reduxForm({ form: 'xeroInputData' })(withTranslation()(XeroInputDataForm));